/**Goal of this function is to create sound based channels for sounds that will overlap
 * 
 * @param {*} Scene 
 */
export function CreateSoundLib(Scene)
{
    const ChannelObject = {
        Chan1: Scene.sound.addAudioSprite('gameAudio'),//Tray open close, lights_garland, pick up orn, place orn
        Chan2: Scene.sound.addAudioSprite('gameAudio'),//Background swap, fireplace fall in
        Chan3: Scene.sound.addAudioSprite('gameAudio'),//Tree select, Gift shake and land,
        Chan4: Scene.sound.addAudioSprite('gameAudio'),//start over, undo
        Chan5: Scene.sound.addAudioSprite('gameAudio')
    }

    return ChannelObject;
}



// export default class SoundChannelManager
// {

// }

